import { useState } from "react";
import { TariffWithPricesViewType } from "../../../store/Catalogs/types";
import { CopyPlus } from "lucide-react";
import { TariffVariantDialog } from "./tariff-variant-dialog.component";
import { useCatalogsStore } from "../../../store/Catalogs";

interface TariffActionsProps {
	tariff: TariffWithPricesViewType;
	onVariantCreated?: (codeE: string, affectedTemplateIds: number[]) => void;
}

export const TariffActions: React.FC<TariffActionsProps> = ({ tariff, onVariantCreated }) => {
	const [variantDialogOpen, setVariantDialogOpen] = useState(false);
	const createTariffVariant = useCatalogsStore((state) => state.createTariffVariant);

	const handleVariantClick = (e: React.MouseEvent) => {
		e.stopPropagation();
		setVariantDialogOpen(true);
	};

	const handleCreateVariant = async (codeE: string) => {
		const result = await createTariffVariant(
			tariff.id || '',
			!tariff.is_custom,
			codeE
		);
		if (!result.success) {
			throw new Error('Failed to create variant');
		}
		if (result.affectedTemplateIds && result.affectedTemplateIds.length > 0 && onVariantCreated) {
			onVariantCreated(codeE, result.affectedTemplateIds);
		}
	};

	return (
		<>
			<div className="flex gap-1">
				{!tariff.is_deactivated && tariff.code && (
					<button
						onClick={handleVariantClick}
						className="p-1 hover:bg-gray-100 rounded"
						title="Variante erstellen"
					>
						<CopyPlus className="h-4 w-4 text-gray-600" />
					</button>
				)}
			</div>

			{variantDialogOpen && (
				<TariffVariantDialog
					tariff={tariff}
					isOpen={variantDialogOpen}
					onClose={() => setVariantDialogOpen(false)}
					onCreateVariant={handleCreateVariant}
				/>
			)}
		</>
	);
};
